export const LANGUAGE = {
  EN: 'en',
  ZH_CN: 'zh-CN',
  ZH_TW: 'zh-TW',
  KO: 'ko',
}

export const TABLE_TYPES = {
  BARCCART: 'barccart',
  MARBLE: 'marble',
}

export const AVAILABLE_TEAMS = [
  'China',
  'Vietnam',
  'Thailand',
  'Japan',
  'Korea',
  'USA',
  'Canada',
  'Brazil',
  'Argentina',
  'Indonesia',
  'India',
  'Australia',
  'Israel',
  'Palestine',
  'Ukraine',
  'Russia',
  'Ho Chi Minh',
  'Hanoi',
  'Hai Phong',
  'Can Tho',
  'Da Nang',
  'Bien Hoa',
  'Thuan An',
  'Hai Duong',
  'Di An',
  'Thanh Hoa',
  'Nha Trang',
  'Nam Dinh',
  'Hue',
  'Vung Tau',
  'Thai Nguyen',
  'Quy Nhon',
]

/* spot type */
export const BET_TYPES = {
  PLAYER_PAIR: 'playerPair',
  PLAYER: 'player',
  TIE: 'tie',
  BANKER: 'banker',
  BANKER_PAIR: 'bankerPair',
  PERFECT_PAIR: 'perfectPair',
  BANKER_BONUS: 'bankerBonus',
  PLAYER_BONUS: 'playerBonus',
  EITHER_PAIR: 'eitherPair',
  SUPER_6: 'super6',
  PLAYER_UNDER: 'playerUnder',
  PLAYER_OVER: 'playerOver',
  BANKER_UNDER: 'bankerUnder',
  BANKER_OVER: 'bankerOver',
  OVER: 'over',
  UNDER: 'under',
}

export const DYNAMIC_ODDS = {
  [BET_TYPES.PLAYER]: 1,
  [BET_TYPES.BANKER]: 0.95,
  [BET_TYPES.PLAYER_PAIR]: 11,
  [BET_TYPES.BANKER_PAIR]: 11,
  ncBanker: 1,
}
